import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SymbolAlertComponent } from '@core/components/symbol-alert/symbol-alert.component';

@NgModule({
    declarations: [
        SymbolAlertComponent
    ],
    imports     : [
        CommonModule
    ],
    exports     : [
        SymbolAlertComponent
    ]
})
export class SymbolAlertModule
{
}
